var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrackman = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 32,
    viewBox: "0 0 205 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tm-logo-svg",
    clipPath: "url(#clip0_6249_135165)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M118.776 3.91602H116.04V17.0159H118.776V3.91602Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M81.3859 6.67059L84.6635 12.1517H78.1084L81.3859 6.67059ZM79.9422 3.91992L72.0752 17.0198H75.2109L76.6748 14.5528H86.092L87.556 17.0198H90.6916L82.8246 3.91992H79.9372H79.9422Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M128.583 3.91992L118.852 10.4597L128.613 17.0198H133.284L123.522 10.4597L133.253 3.91992H128.583Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M155.857 3.91602L148.927 13.7384L142.007 3.91602H138.456V17.021H141.197V7.39108L147.949 17.021H149.91L156.662 7.39108V17.021H159.403V3.91602H155.857Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M173.789 6.67059L177.067 12.1517H170.512L173.789 6.67059ZM172.346 3.91992L164.479 17.0198H167.614L169.083 14.5528H178.5L179.964 17.0198H183.1L175.233 3.91992H172.346Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M202.187 3.91992V13.9297L191.635 3.91992H188.216V17.0198H190.956V7.00493L201.518 17.0198H204.928V3.91992H202.187Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M31.2759 3.91016V6.3113H37.5928V17.01H40.3333V6.3113H45.9411L47.3696 3.91016H31.2759Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M107.585 12.9984C107.302 13.9558 106.41 14.6346 105.412 14.6346H99.5105C98.4214 14.6346 97.4893 13.9659 97.2867 12.8059C97.0131 11.2153 96.9827 9.67022 97.2715 8.19103C97.4994 7.03099 98.4214 6.2762 99.5105 6.2762C100.6 6.2762 105.412 6.28127 105.412 6.28127C106.43 6.28127 107.312 6.94487 107.585 7.89722L109.91 6.33192C109.252 5.0503 107.849 3.90039 105.827 3.90039H99.004C96.7852 3.90039 95.1945 5.45049 94.6778 7.14244C94.1409 8.91036 94.1662 12.0207 94.6627 13.6974C95.1996 15.4958 96.7244 16.9952 99.004 16.9952H105.822C107.859 16.9952 109.252 15.8402 109.91 14.5535L107.58 12.9832L107.585 12.9984Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M63.1996 10.4656H55.2313V6.27626H63.1996C64.3343 6.27626 65.2512 7.18809 65.2867 8.37346C65.2512 9.56897 64.3343 10.4707 63.1996 10.4707M67.7486 8.37346C67.7486 5.80009 65.8794 3.92578 63.5846 3.92578H52.4907V17.0155H55.2313V12.8009H62.1105L64.6231 17.0257H67.7537L65.0486 12.5223C66.624 11.8992 67.7537 10.3136 67.7537 8.37346",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-orange",
    d: "M19.3256 0C20.2172 0 20.9416 0.724395 20.9416 1.61596V19.3256C20.9416 20.2172 20.2172 20.9416 19.3256 20.9416H8.33306C8.17602 20.9416 8.05445 20.8048 8.06964 20.6478C9.05745 12.2235 13.5457 3.30283 16.5192 0.0303942C16.5395 0.0101314 16.5648 0 16.5952 0H19.3256Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-orange",
    d: "M1.61596 0H14.9894C15.0249 0 15.0401 0.0405256 15.0147 0.0607883C9.47285 4.70097 5.12142 14.1738 3.30283 20.6832C3.25724 20.8352 3.12047 20.9467 2.95837 20.9467H1.61596C0.724395 20.9467 0 20.2223 0 19.3307V1.61596C0 0.724395 0.724395 0 1.61596 0Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M87.3677 26.666V31.9394H88.0769V29.5129H92.2257V28.9304H88.0769V27.2486H92.0534L92.3878 26.666H87.3677Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M100.047 30.2933C100.047 31.2102 99.4946 31.4179 98.8057 31.4179H95.9132C95.2293 31.4179 94.6771 31.2153 94.6771 30.2933V28.3126C94.6771 27.3957 95.2293 27.1931 95.9132 27.1931H98.8057C99.4896 27.1931 100.047 27.3957 100.047 28.3126V30.2933ZM98.8817 26.6055H95.8423C94.4137 26.6055 93.9629 27.2488 93.9629 28.5811V30.0248C93.9629 31.3571 94.4137 32.0004 95.8423 32.0004H98.8817C100.31 32.0004 100.761 31.3571 100.761 30.0248V28.5811C100.761 27.2488 100.31 26.6055 98.8817 26.6055Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M116.976 27.2486L118.749 30.2424H115.209L116.982 27.2486H116.976ZM116.531 26.666L113.395 31.9394H114.206L114.859 30.825H119.084L119.737 31.9394H120.548L117.412 26.666H116.526H116.531Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M130.71 30.6539C130.71 31.1199 130.472 31.358 129.808 31.358H126.034V29.5141H129.697C130.345 29.5141 130.71 29.6154 130.71 30.2739V30.6539ZM126.034 27.2497H129.757C129.975 27.2497 130.507 27.3206 130.507 27.8019V28.2831C130.507 28.81 130.107 28.9315 129.722 28.9315H126.034V27.2497ZM130.37 29.1494V29.119C131.014 29.0531 131.221 28.6681 131.221 28.2882V27.8374C131.221 27.2345 130.917 26.6621 129.823 26.6621H125.32V31.9355H129.894C130.771 31.9355 131.424 31.5505 131.424 30.8109V30.1828C131.424 29.3824 130.928 29.1696 130.365 29.1392",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M133.445 26.666V31.9394H138.658V31.3569H134.16V29.5129H138.455V28.9304H134.16V27.2486H138.628V26.666H133.445Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M139.97 26.666V27.2486H142.634V31.9394H143.349V27.2486H145.684L146.013 26.666H139.97Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M147.224 26.666V27.2486H149.889V31.9394H150.603V27.2486H152.938L153.273 26.666H147.224Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M154.736 26.666V31.9394H159.949V31.3569H155.451V29.5129H159.746V28.9304H155.451V27.2486H159.584L159.919 26.666H154.736Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M176.691 29.9079H179.396V30.4398C179.396 31.1693 178.961 31.4175 178.247 31.4175H175.455C174.771 31.4175 174.219 31.2149 174.219 30.298V28.3173C174.219 27.4004 174.771 27.1978 175.455 27.1978H177.304C178.849 27.1978 179.27 27.2535 179.351 27.9323L179.949 27.5169C179.685 26.7723 178.86 26.6152 178.074 26.6152H175.379C173.951 26.6152 173.5 27.2586 173.5 28.5909V30.0346C173.5 31.3669 173.951 32.0102 175.379 32.0102H178.323C179.64 32.0102 180.106 31.4986 180.106 30.065V29.3355H176.686V29.9181L176.691 29.9079Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M184.583 27.2486L186.356 30.2424H182.815L184.588 27.2486H184.583ZM184.138 26.666L181.002 31.9394H181.812L182.466 30.825H186.691L187.344 31.9394H188.155L185.024 26.666H184.138Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M196.467 26.666L193.382 31.0884L190.302 26.666H189.188V31.9394H189.902V27.3043H189.917L193.129 31.9394H193.641L196.852 27.3043H196.868V31.9394H197.582V26.666H196.467Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M199.72 26.666V31.9394H204.927V31.3569H200.434V29.5129H204.725V28.9304H200.434V27.2486H204.563L204.897 26.666H199.72Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M107.104 29.2506C107.104 29.2506 107.053 29.2506 107.028 29.2506H103.507V27.2193H106.967C107.585 27.2193 107.93 27.3712 107.93 27.9994V28.5009C107.93 29.0227 107.621 29.2304 107.099 29.2506M108.644 28.0703C108.644 26.8393 108.097 26.6367 107.134 26.6367H102.793V31.9101H103.507V29.8332H106.648L106.871 30.2131L107.215 30.7957L107.869 31.9101H108.679L107.433 29.8129C108.563 29.7015 108.644 29.1189 108.644 28.0703Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tm-logo-grey",
    d: "M166.221 29.2506C166.221 29.2506 166.17 29.2506 166.145 29.2506H162.624V27.2193H166.084C166.702 27.2193 167.046 27.3712 167.046 27.9994V28.5009C167.046 29.0227 166.737 29.2304 166.216 29.2506M167.761 28.0703C167.761 26.8393 167.213 26.6367 166.251 26.6367H161.91V31.9101H162.624V29.8332H165.765L165.988 30.2131L166.332 30.7957L166.986 31.9101H167.796L166.55 29.8129C167.679 29.7015 167.761 29.1189 167.761 28.0703Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6249_135165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204.928,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrackman);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Trackman.5eff5670db7fe9780fd4976418ac63fb.svg";